<template>
  <div class="MessageBoard">
    <div class="top">
      <div class="search">
        <p>用户意见反馈</p>
        <el-input placeholder="搜索" v-model="content" class="input-with-select" size="medium">
          <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
        </el-input>
      </div>
      <!-- <div class="total">
        <p>共 234 条 意见反馈内容</p>
        <p>已回复 7 条</p>
      </div> -->
    </div>

    <div class="form-box">
      <div class="content content1" :class="isEdit ? 'hs0' : 'hs1'" @click.stop="handleShowEdit(true)">
        <el-input placeholder="点击创建意见反馈" size="medium" style="width: calc(100% - 70px);" readonly></el-input>
        <el-button type="primary" size="mini" disabled style="float: right;margin-top: 5px;cursor: pointer">提交</el-button>
      </div>
      <div :class="isEdit ? 'h1' : 'h0'">
        <div class="content">
          <el-input v-model="titdata" placeholder="请输入反馈标题" size="medium" maxlength="50" show-word-limit></el-input>
          <el-input
            class="title-input"
            type="textarea"
            placeholder="请描述一下详细内容"
            v-model="data"
            maxlength="300"
            :autosize="{ minRows: 5, maxRows: 10}"
            show-word-limit />
        </div>
        <div class="pic-btn">
          <div class="pic">
            <i class="el-icon-picture-outline"></i>
            <el-upload
              class="upload-demo"
              action
              :limit='2'
              list-type="picture"
              :on-remove='handleRemove'
              :http-request='handleHttpRequest'
              :before-upload='beforeAvatarUpload'
              :on-change='handleSomeimg'
              :file-list="fileList">
              <span>插入图片<span style="font-size: 12px;color:#B2B2B2"> (最多两张)</span></span>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </div>
          <div class="btn">
            <el-button plain size="mini" @click="handleShowEdit(false)">取消</el-button>
            <el-button type="primary" size="mini" @click="handleSave" :loading="loading">提交</el-button>
          </div>
        </div>
      </div>
    </div>

    <ul class="ul">
      <li class="li" v-for="(item, i) in list" :key="i">
        <h1><el-tag v-if="item.isReply" class="c2" size="mini">已回复</el-tag>{{item.titdata}}</h1>
        <p>{{item.data}}</p>
        <div class="img" v-if="item.backImg">
          <el-image
            v-for="(ci, ii) in item.file"
            :key="ii"
            style="width: 100px; height: 100px;border-radius: 5px;margin-right: 20px;"
            :src="`${baseUrlAddr}/front/back/up/backImg/download?fileName=${ci}`"
            :preview-src-list="[`${baseUrlAddr}/front/back/up/backImg/download?fileName=${ci}`]"
            />
        </div>
        <div class="time">
          <span class="c1">{{ item.createTime }}</span>
          <el-button v-if="item.isReply" class="btn" type="primary" size="mini" plain :icon="item.open ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" @click="handleOpen(i)">{{ item.open ? '收起' : '展开' }}</el-button>
        </div>
        <div class="details" v-show="item.open && item.isReply">
          <!-- <h4>{{item.replayData.length}}条回复</h4> -->
          <ul>
            <li v-for="(rep, ri) in item.replayData" :key="ri">
              <h5>{{rep.isUser ? '我' : '官方回复'}}：</h5>
              <p>{{rep.data}}</p>
              <span>{{rep.updateTime}}</span>
              <!-- <div class="img">
                <el-image
                  v-for="(ci, ii) in rep.backImg.split(';')"
                  :key="ii"
                  style="width: 80px; height: 80px;border-radius: 4px;margin-right: 10px;"
                  :src="`${baseUrlAddr}/front/back/up/backImg/download?fileName=${ci}`"
                  :preview-src-list="[`${baseUrlAddr}/front/back/up/backImg/download?fileName=${ci}`]"
                  />
              </div> -->
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="block" v-if="pagination.total > 10">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name:'MessageBoard',
  components: {
  },
  data() {
    return {
      content: '',
      isEdit: false,
      loading: false,
      titdata: '',
      data: '',
      file: [],
      fileList: [],
      list: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData () {
      let { content, pagination: { page, pageSize } } = this
      let { code, data, msg } = await this.request.post('/front/back/up/query', { content, page, pageSize })

      if (code != 200) return this.$message({ type: 'warning', message: msg })

      this.list = data.data.map(item => {
        item.open = false
        item.replayData = []
        item.file = item.backImg.split(';')
        return item
      })

      this.isEdit = data.totalCount <= 0
      this.pagination.total = data.totalCount
    },
    async getDatails (i, id) {
      let { code, data, msg } = await this.request.post(`/front/back/up/${id}`, {})
      if (code != 200) return

      // this.list[i].replayData = data
      this.list[i].replayData = data.splice(1)
    },
    handleSizeChange (e) {
      this.pagination.pageSize = e
      this.pagination.page = 1
      this.getData()
    },
    handleCurrentChange (e) {
      this.pagination.page = e
      this.getData()
    },
    handleOpen (i) {
      const { open } = this.list[i]
      this.list[i].open = !open
      if (!open) {
        this.getDatails(i, this.list[i].id)
      }
    },
    handleShowEdit (isEdit) {
      this.isEdit = isEdit
      this.titdata = ''
      this.data = ''
    },
    async handleSave () {
      let { titdata, data, file } = this

      if (!titdata || !data) {
        return this.$message({ type: 'warning', message: '标题和详细内容不能缺失哦！' })
      }

      let backImg = file.join(';')

      this.isLoading = true
      let { code, msg } = await this.request.post('/front/back/up/add', { titdata, data, backImg })
      this.isLoading = false

      if (code == 200) {
        this.isEdit = false
        this.titdata = ''
        this.data = ''
        this.pagination.page = 1
        this.getData()
        this.$message({ type: 'success', message: msg })
      }
    },
    handleRemove (file, fileList) {
      let fileID = file.uid
      this.fileList = fileList.filter((val) => {
        return val.uid != fileID
      })
      this.file = this.fileList
    },
    handleHttpRequest (obj) {
      let formData = new FormData()
      formData.append('file', this.fileList[this.fileList.length - 1].raw)

      this.request.post('/front/back/up/backImg/upload', formData).then((res) => {
        if (res.code != 200) return
        this.msg.success('上传成功')
        console.log('上传', res)
        const files = res.data
        this.file.push(files)
        console.log('push信息', this.file)
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpeg或jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传1MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handleSomeimg (file, fileList) {
      this.fileList = fileList
    },
  }
};
</script>

<style lang="scss" scoped>
.MessageBoard {
  padding: 20px 10%;
  height: 100%;
  margin: 0px auto;
  overflow: auto;
  box-sizing: border-box;
  .top {
    .search {
      // height: 50px;
      p {
        display: inline-block;
        font-size: 20px;
        font-weight: 600;
      }
      .input-with-select {
        width: 270px;
        float: right;
        margin-top: -5px;
      }
    }
    .total {
      p {
        color: #8F8F92;
        font-size: 14px;
        display: inline-block;
        &:last-child {
          float: right;
        }
      }
    }
  }
  .form-box {
    border-radius: 4px;
    width: calc(100% - 40px);
    // min-height: 198px;
    background: #fff;
    padding: 20px;
    margin-top: 20px;
    overflow: hidden;
    .h0 {
      height: 0px;
      transition: .3s;
      overflow: hidden;
    }
    .h1 {
      min-height: 191px;
      transition: .3s;
    }
    .hs0 {
      height: 0px;
      // width: 200px;
      transition: .5s;
      overflow: hidden;
    }
    .hs1 {
      // width: 100%;
      height: 36px;
      transition: .3s;
    }
    .content {
      // min-height: 153px;
      border-radius: 4px;
      background-color: #F2F8FC;
      .el-input__inner {
        background: transparent!important;
      }
    }
    .content1 {
      background-color: #fff;
      cursor: pointer!important;
    }
    .pic-btn {
      .btn {
        float: right;
        margin-top: 18px;
      }
      .pic {
        margin-top: 20px;
        display: inline-block;
      }
      .upload-demo {
        display: inline-block;
        margin-left: 5px;
        vertical-align: top;
      }
    }
  }
  .ul {
    // border: 1px solid red;
    .li {
      margin-top: 10px;
      min-height: 100px;
      background: #fff;
      padding: 15px;
      border-radius: 4px;
      .c2 {
        margin-right: 10px;
      }
      h1 {
        font-size: 15px;
        margin-bottom: 10px;
        font-weight: normal;
      }
      p {
        font-size: 14px;
        color: #B2B2B2;
      }
      .img {
        margin-top: 10px;
      }
      .time {
        margin-top: 10px;
        >span {
          font-size: 12px;
          color: #B2B2B2;
        }
        .btn {
          float: right;
        }
      }
      .details {
        border: 1px solid #F2F8FC;
        margin-top: 15px;
        box-sizing: border-box;
        padding: 10px;
        h4 {
          font-weight: 500;
          font-size: 13px;
          line-height: 50px;
          border-bottom: 1px solid #F2F8FC;
        }
        ul {
          li {
            font-size: 14px;
            h5 {
              font-weight: 600;
              font-size: 14px;
              line-height: 30px;
            }
            p {
              color: #333;
            }
            span {
              font-size: 13px;
              color: #B2B2B2;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
  .block {
    height: 80px;
    margin-top: 30px;
    float: right;
  }
}
</style>
<style lang="scss">
.MessageBoard {
  .search {
    .el-input__inner, .el-input-group__append, .el-input-group__prepend {
      border: none;
    }
    .el-input-group__append, .el-input-group__prepend {
      background-color: #fff;
    }
  }
  .form-box {
    .content {
      .title-input {
        border-top: 1px solid #DCDFE6;
      }
      .el-input__inner, .el-textarea__inner {
        background: transparent;
        border: none;
      }
    }
    .content1 {
      .el-input__inner, .el-textarea__inner {
        background: #F2F8FC;
        border: none;
        cursor: pointer;
      }
    }
    .pic-btn {
      .el-upload-list {
        width: 580px;
      }
      .el-upload-list--picture .el-upload-list__item {
        display: inline-block;
        width: 240px;
        margin-right: 10px;
      }
    }
  }
}
</style>
